module.exports = __webpack_public_path__ + "static/media/pescadores.de6a247d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/pescadores.jpg
// module id = 205
// module chunks = 0